import React, { useState } from 'react';
import { ReactComponent as CloneIcon } from 'assets/svg/clone.svg';
import { ReactComponent as TrashIcon } from 'assets/svg/trash.svg';

import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowDown from '@material-ui/icons/ArrowDropDown';

import { PrimaryTableRow, CollapsibleRows } from '@Calix-Commerce/design-system/components';

import { TableRowFull, NoResultMessage } from 'components';
import { getItemPriceDisplay, getWarrantyStatus, getShippingType } from 'utils/helpers';

import {
  Table,
  Exception,
  ItemTitle,
  TableRow,
  IconsWrapper,
  ItemDetailTable,
} from './styledComponents';
import { useFormatPrice } from 'utils/hooks/useFormatPrice';

const ItemsTable = ({
  items = [],
  shippingPrice = 0,
  shippingMethod,
  onItemRemove,
  onItemClone,
  currencyCode,
  cloneable = false,
  showTotals = false,
}) => {
  const shippingTotalPrice = shippingPrice * items.length;

  const [rowExpanded, setRowExpanded] = useState([]);

  const formatPrice = useFormatPrice();

  const setOpenRow = (index) => {
    if (rowExpanded.indexOf(index) > -1) {
      setRowExpanded(rowExpanded.filter((item) => item !== index));
    } else {
      setRowExpanded([...rowExpanded, index]);
    }
  };

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Serial Number</th>
            <th>In Warranty</th>
            <th>Price</th>
          </tr>
        </thead>

        {items.map((item, index) => {
          return (
            <React.Fragment key={item.serialNumber}>
              <tbody>
                <TableRow isRemovable={onItemRemove}>
                  <td>
                    <div onClick={() => setOpenRow(index)}>
                      {rowExpanded.indexOf(index) > -1 ? (
                        <ArrowDown style={{ marginBottom: '-5px' }} />
                      ) : (
                        <ArrowRight style={{ marginBottom: '-5px' }} />
                      )}{' '}
                      <ItemTitle>{item.serialNumber}</ItemTitle>
                    </div>
                  </td>
                  <td>
                    <div>{getWarrantyStatus(item)}</div>
                  </td>
                  <td>
                    <div>
                      {getItemPriceDisplay(item, formatPrice, currencyCode)}
                      <IconsWrapper>
                        {cloneable && (
                          <CloneIcon
                            title="Clone Item"
                            className={onItemClone ? '' : 'disabled'}
                            onClick={() => onItemClone && onItemClone(item)}
                          />
                        )}
                        {onItemRemove && (
                          <TrashIcon title="Remove Item" onClick={() => onItemRemove(item)} />
                        )}
                      </IconsWrapper>
                    </div>
                  </td>
                </TableRow>
                <TableRowFull>
                  <td colSpan="3">
                    {item.partNumber && (
                      <div>
                        <b>{item.partNumber}</b>
                      </div>
                    )}
                    {item.createdDate && (
                      <div>Created Date: {new Date(item.createdDate).toLocaleDateString()}</div>
                    )}
                    <div>{item.description || item.partName}</div>
                    {item.exceptionDescription && (
                      <Exception>Exception: {item.exceptionDescription}</Exception>
                    )}
                  </td>
                </TableRowFull>
              </tbody>
              <CollapsibleRows show={rowExpanded.indexOf(index) > -1}>
                <PrimaryTableRow>
                  <td colSpan="3" style={{ paddingLeft: '50px' }}>
                    <ItemDetailTable>
                      <tbody>
                        <tr>
                          <td>
                            <b>Failure Code:</b>
                          </td>
                          <td>{item.failureCode}</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Service Activity:</b>
                          </td>
                          <td>{item.serviceActivity}</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Description of Failure:</b>
                          </td>
                          <td>{item.failureDescription}</td>
                        </tr>

                        {item.reviewDescription ? (
                          <tr>
                            <td>
                              <b>Details:</b>
                            </td>
                            <td>{item.reviewDescription}</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </ItemDetailTable>
                  </td>
                </PrimaryTableRow>
              </CollapsibleRows>
            </React.Fragment>
          );
        })}
        {shippingMethod ? (
          <tbody>
            <TableRow>
              <td colSpan="2">
                <div>
                  <ItemTitle>Shipping</ItemTitle>
                </div>
              </td>
              <td>
                <div>{formatPrice(shippingTotalPrice, currencyCode)}</div>
              </td>
            </TableRow>
            <TableRowFull>
              <td colSpan="3">
                <div>{getShippingType(shippingMethod)}</div>
              </td>
            </TableRowFull>
          </tbody>
        ) : null}
      </Table>
      {items.length ? null : <NoResultMessage>Your RMA Case doesn’t have items.</NoResultMessage>}
    </>
  );
};

export { ItemsTable };
